var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiIconShoppingCart = function SvgUiIconShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.399 5.17)",
    stroke: "currentColor",
    strokeWidth: 1.6,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.69 2.321v8.1M5.76 13.014h8.37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.801,
    y: 10.628,
    width: 4.4,
    height: 4.4,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.201,
    y: 11.628,
    width: 3.4,
    height: 3.4,
    rx: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.481 8.64V1.32H16.22v7.691h-.688c-.962 0-1.868.453-2.446 1.222H7.433l-.006-.01A3.167 3.167 0 0 0 5.481 8.64zM7.25 4.53h4.117M7.25 7.322h4.117"
  }))));
};
export default SvgUiIconShoppingCart;